import React, { Suspense, useState } from "react"
import PropTypes from "prop-types"

import {
  chatbot_setting,
  brand_features,
  translator,
} from "../../data/config/brandSetup"
import { TYPES } from "../../data/config/constants"
import { LangContext } from "../../modules/context"
import chatbotStyle from "../../data/config/chatbotStyle"

const LottieContainer = React.lazy(() => import("./lottiecontainer"))
const FloatingMenu = React.lazy(() => import("./floatingmenu"))
const CloseTrigger = React.lazy(() => import("./closetrigger"))

const SHOW_TRIGGER = brand_features.enable_trigger_brand_logic
  ? brand_features.showTriggerByBrandLogic()
  : true

const TriggerChatBot = ({ is_chat_open, handleSocketConnection }) => {
  const [showTrigger, setShowTrigger] = useState(SHOW_TRIGGER)

  if(chatbot_setting.clientAction.triggerIcon){
    window.handleOriChatbotTriggerVisibility = (visibility) => {
      if(typeof visibility === "boolean") setShowTrigger(visibility)
    }
  }

  const handleChatInterfaceView = () => {
    handleSocketConnection(!is_chat_open)
    if (is_chat_open && chatbot_setting.gtm.enable && chatbot_setting.gtm.close_bot && window.dataLayer )
      window.dataLayer.push({ event: chatbot_setting.gtm.close_bot })
  }

  return (
    <LangContext.Consumer>
      {(lang) => (
        <React.Fragment>
          {is_chat_open && chatbot_setting.show_trigger_close && (
            <Suspense fallback={null}>
              <CloseTrigger onClick={handleChatInterfaceView} />
            </Suspense>
          )}
          {!is_chat_open &&
            chatbot_setting.trigger_type === TYPES.LOTTIE &&
            showTrigger && (
              <Suspense fallback={null}>
                <div
                  className={`ori-fixed ori-z-index-99991 ori-cursor-ptr ${chatbotStyle.lottieTriggerClass}`}
                  onClick={handleChatInterfaceView}
                >
                  <LottieContainer />
                </div>
              </Suspense>
            )}
          {chatbot_setting.trigger_type === TYPES.FLAOTING_MENU &&
            showTrigger && (
              <Suspense fallback={null}>
                <FloatingMenu openChatbot={handleSocketConnection} />
              </Suspense>
            )}
          {!is_chat_open &&
            chatbot_setting.trigger_type === TYPES.DEFAULT &&
            showTrigger && (
              <div
                id="oriDefaultTrigger"
                className={`ori-fixed ori-z-index-99991 ori-cursor-ptr ${chatbotStyle.defaultTriggerClass}`}
                onClick={handleChatInterfaceView}
              >
                <img
                  src={translator.assets[lang].trigger}
                  alt=""
                  className="ori-full-parent-height"
                />
              </div>
            )}
        </React.Fragment>
      )}
    </LangContext.Consumer>
  )
}

TriggerChatBot.propTypes = {
  is_chat_open: PropTypes.bool.isRequired,
  handleSocketConnection: PropTypes.func,
}

export default TriggerChatBot
